import React, { lazy, Suspense } from "react";
const NotificationDisplay: React.LazyExoticComponent<any> = lazy(
  () => import("app/components/NotificationDisplay/NotificationDisplay")
);

const NotificationHeader = () => {
  return (
    <div className="nav-bar__notification-header">
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <NotificationDisplay />
      </Suspense>
    </div>
  );
};

export default NotificationHeader;
